import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import { MobileModulesNav } from "@/components/nav/TopModulesNav";
import WearablesRouteCompanion from "@/components/wearables/v2/WearablesRouteCompanion";
import { resolveRouteShellPolicy } from "@/config/shellPolicy";

export default function BottomTabShell(): JSX.Element {
  const location = useLocation();
  const shellPolicy = React.useMemo(() => resolveRouteShellPolicy(location.pathname), [location.pathname]);
  const suppressWearablesCompanion =
    location.pathname === "/guided/start-from-world" || location.pathname === "/omnistudio";

  return (
    <>
      <div className={shellPolicy.showBottomTabs ? "min-h-full pb-[72px] md:pb-0" : "min-h-full"}>
        <Outlet />
      </div>
      {suppressWearablesCompanion ? null : <WearablesRouteCompanion />}
      <div className={shellPolicy.showBottomTabs ? "md:hidden" : "hidden"}>
        <MobileModulesNav />
      </div>
    </>
  );
}